import { BenefitsInformationView } from '@/features/crew-benefits/components/BenefitsInformationView';
import { JobApplicationWidget } from '@/features/job-applications/components/JobApplicationWidget';
import { JobApplicationStatusProvider } from '@/shared/contexts/JobApplicationStatusContext';
import { createFileRoute, useParams } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/profiles/benefits/view/$userID')({
  component: EmployeeBenefitsDetail,
})

function EmployeeBenefitsDetail() {
  const { userID } = useParams({ from: Route.id })
  const userIDNum = parseInt(userID, 10)

  return (
    <JobApplicationStatusProvider>
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-12 gap-6">
          {/* Employee information - Left Panel */}
          <main className="col-span-12 lg:col-span-8">
            <BenefitsInformationView userID={userIDNum} />
          </main>

          {/* Right Panel - Job Applications */}
          <aside className="col-span-12 lg:col-span-4 space-y-6">
            
            <JobApplicationWidget userID={userIDNum} />
            
          </aside>
        </div>
      </div>
    </div>
    </JobApplicationStatusProvider>
  );
}
